import { Button, FormField, Input, SpaceBetween } from "@amzn/awsui-components-react";
import { FC, useState } from "react";
import { MapEngineHandle } from "../../react";
import { isValidTile, tileToCenter } from "../../engine/style";

export interface ZoomToTilePanelProps {
    handle: MapEngineHandle | null;
}

/**
 * Navigate to an XYZ tile: converts z/x/y to the tile's WGS84 center (via C2
 * tileMath) and flies the map there. Ported from 1.0 ZoomToTile, using the v2
 * engine's flyTo.
 */
const ZoomToTilePanel: FC<ZoomToTilePanelProps> = ({ handle }) => {
    const [z, setZ] = useState("5");
    const [x, setX] = useState("9");
    const [y, setY] = useState("12");

    const tile = { x: parseInt(x, 10), y: parseInt(y, 10), z: parseInt(z, 10) };
    const valid = isValidTile(tile);

    const navigate = () => {
        if (!valid) return;
        const center = tileToCenter(tile);
        handle?.engine()?.flyTo({ lng: center.lng, lat: center.lat, zoom: tile.z, animate: false });
    };

    return (
        <SpaceBetween size="s">
            <FormField label="Z">
                <Input type="number" value={z} onChange={({ detail }) => setZ(detail.value)} />
            </FormField>
            <FormField label="X">
                <Input type="number" value={x} onChange={({ detail }) => setX(detail.value)} />
            </FormField>
            <FormField label="Y">
                <Input type="number" value={y} onChange={({ detail }) => setY(detail.value)} />
            </FormField>
            <Button variant="primary" disabled={!valid} onClick={navigate}>
                Navigate
            </Button>
        </SpaceBetween>
    );
};

export default ZoomToTilePanel;
